import { getMigrationMessageProps, getNumberofDaysBetweenDates
// @ts-expect-error not migrated TS yet
} from 'EmailComponents/utils/portalMigration';
import { messageTextType } from 'EmailData/constants/portalMigration';
import * as storage from 'EmailData/lib/storage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { LOCAL_STORAGE_BASE_KEY } from 'email-management-lib/refactor/utils/constants';
import { WarningIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { EMAIL_TYPE } from 'messaging-types-lib/content/contentEmail';
import { jsx as _jsx } from "react/jsx-runtime";
export const getShouldShowPortalMigrationWarning = ({
  isEligibleForPortalMigration,
  portalMigrationEndDate,
  portalMigrationStartDate,
  emailPublishDate,
  emailType
}) => {
  const diffDaysBetweenStartAndScheduledDate = getNumberofDaysBetweenDates(portalMigrationStartDate, emailPublishDate);
  const diffDaysBetweenEndAndScheduledDate = getNumberofDaysBetweenDates(portalMigrationEndDate, emailPublishDate);
  const shouldShowWarning = isEligibleForPortalMigration && (diffDaysBetweenStartAndScheduledDate === 0 || diffDaysBetweenEndAndScheduledDate === 0);
  const shouldShowLocalTimeWarning = isEligibleForPortalMigration && (diffDaysBetweenStartAndScheduledDate === 0 || diffDaysBetweenStartAndScheduledDate === 1 || diffDaysBetweenEndAndScheduledDate === 0 || diffDaysBetweenEndAndScheduledDate === -1);
  return emailType === EMAIL_TYPE.LOCALTIME_EMAIL ? shouldShowLocalTimeWarning : shouldShowWarning;
};
export const mayBeRenderMigrationWarning = ({
  portalMigrationHoistingHublet,
  portalMigrationStartDate,
  shouldShowPortalMigrationWarning,
  emailType
}) => {
  if (shouldShowPortalMigrationWarning) {
    const msgTextType = emailType === EMAIL_TYPE.LOCALTIME_EMAIL ? messageTextType.localTimeWarningText : messageTextType.warningText;
    const {
      headingText,
      title
    } = getMigrationMessageProps(portalMigrationHoistingHublet, portalMigrationStartDate, msgTextType);
    return /*#__PURE__*/_jsx(Tooltip, {
      headingText: headingText,
      placement: "bottom",
      title: title,
      children: /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "100",
        children: /*#__PURE__*/_jsx(WarningIcon, {
          "data-test-id": "portal-migration-warning"
        })
      })
    });
  }
  return null;
};
export const HAS_SEEN_PORTAL_MIGRATION_ALERT = 'hasSeenPortalMigrationAlert';
export const setHasSeenPortalMigrationAlert = portalId => storage.set(portalId, LOCAL_STORAGE_BASE_KEY, HAS_SEEN_PORTAL_MIGRATION_ALERT, true);
export const getHasSeenPortalMigrationAlert = portalId => storage.get(portalId, LOCAL_STORAGE_BASE_KEY, HAS_SEEN_PORTAL_MIGRATION_ALERT);